import Url from 'urlinator/Url';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { useHistory } from 'react-router-dom';
import { Flex } from 'foundations-components/components/Flex';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import ReportViewer from '../components/ReportViewer';
// @ts-expect-error Untyped import
import { getReport } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { getReports } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { clearReport } from '../actions/reportsActions';
// @ts-expect-error Untyped import
import { selectReport } from '../selectors/reportsSelector';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import requestStatusTypes from '../constants/requestStatusTypes';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { selectGetReportRequestStatus, selectIsUnusedFilterActive
// @ts-expect-error Untyped import
} from '../selectors/reportsSelector';
import { jsx as _jsx } from "react/jsx-runtime";
function isValidReportId(reportId) {
  const checkValidReportId = new RegExp('^([0-9]+)$');
  return checkValidReportId.test(reportId);
}
function SingleReportViewerContainer(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const isUnusedFilterActive = useSelector(selectIsUnusedFilterActive);
  const {
    reportId,
    handleCloseViewerOverride
  } = props;
  const report = useSelector(selectReport);
  const reportStatus = useSelector(selectGetReportRequestStatus);
  useEffect(() => {
    if (isValidReportId(reportId)) {
      dispatch(getReport(reportId));
    }
  }, [reportId, dispatch]);
  const handleCloseViewer = () => {
    if (handleCloseViewerOverride) {
      handleCloseViewerOverride();
    } else {
      const url = new Url(window.location);
      history.push(`/${url.search}`);
      if (!isUnusedFilterActive) {
        // when previewing reports under the unused filter, we don't want to refetch otherwise they'll no longer be in the list
        dispatch(getReports());
      }
      dispatch(clearReport());
    }
  };
  if (reportStatus === requestStatusTypes.PENDING) {
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "small"
      })
    });
  }
  if (reportStatus === requestStatusTypes.FAILED) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "SINGLE_REPORT_VIEWER_FAILURE",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.errors.openReportNormalizationError"
        })
      })
    });
  }
  if (reportStatus === requestStatusTypes.SUCCEEDED) {
    return report && /*#__PURE__*/_jsx(NavMarker, {
      name: "SINGLE_REPORT_VIEWER",
      children: /*#__PURE__*/_jsx(ReportViewer, {
        report: report,
        onClose: handleCloseViewer
      })
    });
  }
  return null;
}
export default SingleReportViewerContainer;